import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { Button, DatePicker, Divider, Image, Input } from "antd";
import { Select } from "antd";
import plus_white from "../../assets/svg/plus_white.svg";
import tag from "../../assets/svg/tag.svg";
import calender from "../../assets/svg/calendar.svg";

import {
	btnStyle,
	inputStyle,
	selectStyle,
} from "../../lib/styles/styleLibrary";
import {
	// DeleteOutlined,
	PlusOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import { useMutation } from "react-query";
import { addTag, editPlan, removeTag } from "../../redux/actions/plans";
import { v4 } from "uuid";

const RightWrapper = styled.div`
	${tw`p-8 pt-4 h-full bg-white w-full flex flex-col container`}
	height: 80vh;
	box-shadow: 0px 30px 60px rgba(32, 56, 85, 0.05);
	border-radius: 10px;
	@media (max-width: 1217px) {
		height: auto;
	}
`;

const EditPlan = (props) => {
	const {
		plan,
		tags,
		isTagLoading,
		setAddTagModal,
		experience,
		couple,
		setEditVisible,
		refetch,
	} = props;
	const { Option } = Select;
	const { mutateAsync: handleEditPlan, isLoading } = useMutation(editPlan);
	let tagid = [];
	plan.set_tags.forEach((tag) => {
		tagid.push(tag.plan_tag.id);
	});
	const [fields, setFields] = useState({
		...(experience === "planner" && { weddingId: couple?.id }),
		title: plan.title,
		description: plan.description,
		planned_date: plan.planned_date,
		tagIds: tagid,
		planId: plan.id,
	});

	useEffect(() => {
		experience === "planner" &&
			setFields({ ...fields, weddingId: couple?.id });
		// eslint-disable-next-line
	}, [experience]);

	const [pd, spd] = useState(moment(plan.planned_date));
	useEffect(() => {
		setFields({ ...fields, planned_date: moment(pd).unix() });
		// eslint-disable-next-line
	}, [pd]);

	const handleEdit = async (e) => {
		e.preventDefault();
		if (
			isEmpty(fields.title) ||
			isEmpty(fields.description) ||
			isNaN(fields.planned_date) ||
			isEmpty(fields.tagIds)
		) {
			return Toast.fire({
				icon: "error",
				title: "All fields are required",
			});
		}
		try {
			const response = await handleEditPlan(fields);
			console.log("\nCreate tag res: =====>\n", response.data);
			const { hasError } = response.data;
			if (hasError) {
				return Toast.fire({
					icon: "error",
					title: `${response.data.errors.title},\n ${response.data.errors.message}`,
				});
			}
			const data = {
				planId: response.data.id,
				tagIds: fields.tagIds,
			};
			console.log(data);
			try {
				addTag(data);
			} catch (err) {}

			Toast.fire({
				icon: "success",
				title: "Plan updated successfully!",
			});

			setFields({
				title: "",
				description: "",
				planned_date: "",
				tagIds: [],
			});
			refetch();
			setEditVisible(false);
		} catch (err) {
			console.log("Error: ", err);
		}
	};

	// console.log(fields);

	return (
		<RightWrapper>
			<h3 tw="font-semibold tracking-wider" style={{ fontSize: "15px" }}>
				Create New Plan
			</h3>

			<div tw="mt-4">
				<Input
					placeholder="Title"
					type="text"
					css={inputStyle}
					value={fields.title}
					onChange={(e) =>
						setFields({
							...fields,
							title: e.target.value,
						})
					}
					tw="w-full text-xs! px-3 py-6 rounded-md"
				/>
			</div>

			<div tw="h-2/4 mb-4">
				<Input.TextArea
					placeholder="What is the task/plan?"
					autoSize={{ minRows: 10 }}
					tw="mb-4 text-xs! h-full! p-4 rounded! box-border"
					css={inputStyle}
					value={fields.description}
					onChange={(e) =>
						setFields({
							...fields,
							description: e.target.value,
						})
					}
				/>
			</div>

			<div tw="relative mt-8 mb-2">
				<div tw="absolute -top-1 left-0 z-10">
					<Image
						preview={false}
						src={tag}
						alt=""
						width={20}
						height={20}
						tw="mr-5 absolute inset-3 opacity-30"
					/>
				</div>
				<Select
					mode="multiple"
					css={selectStyle}
					tw="w-full pl-2"
					placeholder=""
					defaultValue={fields.tagIds}
					onChange={(value) => {
						setFields({ ...fields, tagIds: value });
					}}
					bordered={false}
					loading={isTagLoading}
					defaultActiveFirstOption={true}
					onDeselect={(value) => {
						const rmData = {
							tagIds: [value],
							planId: plan.id,
						};
						removeTag(rmData);
					}}
					dropdownRender={(menu) => (
						<div>
							<div
								style={{
									display: "flex",
									flexWrap: "nowrap",
									padding: 8,
								}}>
								<Button
									onClick={() => setAddTagModal(true)}
									tw="w-full border-appBtnBackground rounded-md font-semibold text-appPink">
									Create new tag <PlusOutlined />{" "}
								</Button>
							</div>
							<Divider style={{ margin: "4px 0" }} />
							{menu}
						</div>
					)}
					suffixIcon={
						<Image
							preview={false}
							src={plus_white}
							alt=""
							width={20}
							height={20}
						/>
					}>
					{tags?.map((tag, i) => {
						return (
							<Option value={tag.id} key={v4()}>
								<div tw="flex flex-row flex-nowrap items-center justify-between">
									<span tw="font-semibold">{tag.name}</span>{" "}
									{/* <span>
                                        <DeleteOutlined tw="text-appPink p-2 bg-gray-50 rounded shadow" />
                                    </span> */}
								</div>
							</Option>
						);
					})}
				</Select>
			</div>
			<hr
				tw="w-full opacity-60"
				style={{ border: "1px solid #ECECEC" }}
			/>
			<div tw="relative inline-flex items-center mt-2">
				<div tw="absolute top-0 left-0 z-10">
					<img src={calender} alt="" tw="mr-4 absolute inset-3" />
				</div>
				<DatePicker
					css={[inputStyle, { fontFamily: "Poppins" }]}
					tw="w-full border-none! shadow-none! font-bold hover:border-none! pl-6"
					placeholder="DD/MM/YY"
					disabledDate={(current) => {
						return current && current < moment().subtract(1, "day");
					}}
					suffixIcon={
						<Image
							preview={false}
							src={plus_white}
							alt=""
							width={20}
							height={20}
						/>
					}
					// format={(e) => moment(e).unix()}
					value={pd}
					onChange={(date) => spd(date)}
				/>
			</div>
			<div tw=" w-full">
				<Button
					loading={isLoading}
					css={btnStyle}
					tw="text-sm"
					onClick={handleEdit}>
					Done
				</Button>
			</div>
		</RightWrapper>
	);
};

export default EditPlan;
